module.exports = __webpack_public_path__ + "img/im_logo.83774fd0.png";